export const MEMBERS_LIMIT_REACHED_MODAL = 'MEMBERS_LIMIT_REACHED_MODAL';
export const ALREADY_INVITED_MODAL_TYPE = 'ALREADY_INVITED_MODAL_TYPE';
export const ALREADY_AN_ADMIN_MODAL = 'ALREADY_AN_ADMIN_MODAL';
export const ONLY_ADMIN_MODAL = 'ONLY_ADMIN_MODAL';
export const DELETE_MODAL_TYPE = 'USER_REMOVE_MODAL';
export const CANCEL_SUBSCRIPTION_ERROR_MODAL = 'CANCEL_SUBSCRIPTION_ERROR_MODAL';
export const CANNOT_ADD_USERS_FROM_OUTSIDE_OF_WORKSPACE =
  'CANNOT_ADD_USERS_FROM_OUTSIDE_OF_WORKSPACE';
